module.exports = __webpack_public_path__ + "img/106044.bb93cb85.png";